import en from './en.json';
import pt from './pt.json';
import es from './es.json';
import hi from './hi.json';

export type Locale = 'en' | 'pt' | 'es' | 'hi';

export type Translations = typeof en;

const dictionaries: Record<Locale, Translations> = { en, pt, es, hi };

export function getTranslations(locale: Locale): Translations {
    return dictionaries[locale] ?? en;
}

export const locales: Locale[] = ['en', 'pt', 'es', 'hi'];

export const localeNames: Record<Locale, string> = {
    en: 'English',
    pt: 'Português',
    es: 'Español',
    hi: 'हिन्दी',
};
